import React from 'react';
import { KindredForBusinessLogo } from '../../../Common/Svg/Logos';
import SocialLinks from '../../../Common/SocialLinks';
import { mobileMediaQuery, themeColor, useBreakPoints } from '../../../Theming';
import styled, { useTheme } from 'styled-components';
import env from '../../../env';
import ButtonLink from '../../../Common/Buttons/Links/ButtonLink';
import { useTranslation } from 'react-i18next';
import { certifiedBadge } from '../../../Assets/Footer';

export const MAIL_TO_SDK_COMMERCIAL_TEAM =
  'mailto:' + env.sdk_commercial_team_email;

const StyledKindredLogo = styled(KindredForBusinessLogo)`
  display: block;
  margin-bottom: 34px;

  ${mobileMediaQuery} {
    margin-bottom: 25px;
  }
`;

const StyledButtonLink = styled(ButtonLink)`
  width: 180px;
  margin-top: 103px;
`;

const ButtonLinkSecondary = styled(ButtonLink)`
  width: 180px;
  margin-top: 103px;
  background-color: ${themeColor('mediumGreen')};
  margin-left: 25px;
  border: 0px;

  ${mobileMediaQuery} {
    margin-top: 20px;
    width: 100%;
  }
`;

const RowContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

const StyledBadge = styled.img`
  width: 148px;
  height: 85px;
  background-size: contain;
  margin-left: -23px;
  margin-top: -13.05px;

  ${mobileMediaQuery} {
    width: 87px;
    height: 54px;
    margin-left: -30px;
    margin-right: 20px;
  }
`;

const StyledText = styled.p`
  margin: 5px 0;
  font-size: 1.25rem;
  line-height: 0.875rem;
  margin-bottom: 20px;
  letter-spacing: 0.5px;
  display: block;
  font-weight: 700;
  margin-left: -42px;
  width: 235px;
  line-height: 30px;
  margin-top: -5px;

  ${mobileMediaQuery} {
    font-size: 0.875rem;
    letter-spacing: normal;
    margin-bottom: 31px;
  }
`;

const StyledRow = styled.div`
  display: flex;
  flex-direction: row;

  ${mobileMediaQuery} {
    margin-top: 31px;
  }
`;

const WrappedRow = styled.div`
  display: flex;
  flex-direction: row;

  ${mobileMediaQuery} {
    flex-direction: column;
  }
`;

const Connect: React.FC = () => {
  const { t } = useTranslation();
  const { colors } = useTheme();
  const { tablet } = useBreakPoints();
  return (
    <>
      <WrappedRow>
        <StyledKindredLogo color={colors.white} />
        <StyledRow>
          <StyledBadge
            alt="Certified Carbon Nuetral Business"
            src={certifiedBadge}
          />
          <StyledText>{t('footer.carbonNetural')}</StyledText>
        </StyledRow>
      </WrappedRow>
      <SocialLinks />
      {!tablet && (
        <RowContainer>
          <StyledButtonLink href={MAIL_TO_SDK_COMMERCIAL_TEAM}>
            {t('footer.contactUs')}
          </StyledButtonLink>
          <ButtonLinkSecondary href={env.get_api_key_url} target="_blank">
            {t('footer.getAPIKey')}
          </ButtonLinkSecondary>
        </RowContainer>
      )}
    </>
  );
};

export default Connect;
